import React, {useState} from 'react';
import {useCategories} from "../hooks/useCategory";
import {SubmitHandler, useForm} from "react-hook-form";
import {Category, NewCategory, RawScore, TypeForm} from "../types";
import {useModal} from "../Contexts/Modal";
import {getError} from "../utils/getError";


export default function FormCategory({category, typeForm}: {category?: Category, typeForm: TypeForm}) {
    const {mutationCreate, mutationUpdate, isLoading} = useCategories();
    const { closeModal } = useModal();
    const [error, setError] = useState<string>("");

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<NewCategory>({
        defaultValues: {
            category: category?.category,
            description: category?.description,
            coefficient: category?.coefficient || 1,
        }
    })

    const onSubmit: SubmitHandler<NewCategory> = async (newCategory: NewCategory) => {
        try {
            if (typeForm == TypeForm.create){
                await mutationCreate.mutateAsync(newCategory);
            } else if (typeForm == TypeForm.update){
                await mutationUpdate.mutateAsync({ id: category!.name, category: newCategory });
            }
            reset()
            closeModal()
        } catch (error: any) {
            setError(getError(error));
        }
    }

    return (
        <form id="form-new-score" onSubmit={handleSubmit(onSubmit)}>
            {typeForm == TypeForm.create ? <h2>Nouvelle catégorie</h2> : <h2>Modifier la catégorie</h2>}
            <label>Nom</label>
            <input autoFocus {...register("category")} required={true}/>
            <label>Coefficient</label>
            <input type={"number"} {...register("coefficient")} required={true}/>
            <label>Description</label>
            <textarea {...register("description")}/>
            <div className={"errorMessage"}>{error}</div>
            <button type="submit" disabled={isLoading}>Sauvegarder</button>
        </form>
    );
}